import React from 'react';

// This is Facebook's logo, you are not allowed to change its color
export const FacebookLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      fill="#1877F2"
      d="M22.76 11.5C22.76 5.281 17.72.24 11.5.24S.24 5.28.24 11.5c0 5.62 4.117 10.279 9.5 11.124v-7.869H6.882V11.5h2.86V9.02c0-2.823 1.68-4.382 4.253-4.382 1.232 0 2.52.22 2.52.22V7.63h-1.42c-1.398 0-1.835.868-1.835 1.759V11.5h3.123l-.499 3.255H13.26v7.869c5.384-.845 9.501-5.504 9.501-11.124Z"
    />
    <path
      fill="#fff"
      d="m15.883 14.755.5-3.255h-3.124V9.388c0-.89.437-1.759 1.835-1.759h1.42V4.86s-1.288-.22-2.52-.22c-2.572 0-4.253 1.558-4.253 4.38V11.5H6.88v3.255h2.86v7.869a11.344 11.344 0 0 0 3.518 0v-7.869h2.624Z"
    />
  </svg>
);

// This is Google's logo, you are not allowed to change its color
export const GoogleLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      fill="#4285F4"
      d="M22.535 11.75c0-.926-.075-1.601-.237-2.302H11.725v4.179h6.206c-.125 1.038-.8 2.602-2.302 3.653l-.021.14 3.343 2.59.231.023c2.127-1.964 3.353-4.855 3.353-8.283Z"
    />
    <path
      fill="#34A853"
      d="M11.725 22.76c3.04 0 5.593-1 7.457-2.727L15.63 17.28c-.951.663-2.227 1.126-3.904 1.126-2.978 0-5.505-1.964-6.406-4.679l-.132.011-3.476 2.69-.045.127c1.852 3.678 5.655 6.205 10.06 6.205Z"
    />
    <path
      fill="#FBBC05"
      d="M5.32 13.727a6.932 6.932 0 0 1-.376-2.227c0-.776.138-1.526.363-2.227l-.006-.15-3.52-2.732-.115.054A11.271 11.271 0 0 0 .465 11.5c0 1.814.438 3.528 1.201 5.055l3.653-2.828Z"
    />
    <path
      fill="#EB4335"
      d="M11.725 4.594c2.115 0 3.54.913 4.354 1.676l3.178-3.103C17.305 1.353 14.765.24 11.725.24c-4.404 0-8.207 2.527-10.06 6.205l3.642 2.828c.913-2.715 3.44-4.68 6.418-4.68Z"
    />
  </svg>
);
